import styled from "styled-components";

export const AppContainer = styled.div`
height: 100vh,
        display: flex,
        justifyContent: center,
        alignItems: center,
        fontSize: 40,
        color: #010101
`